import { CloseSessionDto, ReloadAccessDto, ResponseSearchAccessDto, SearchAccessDto, SuccessResponseDto } from '@/dtos';
import http from '@/helpers/apis/http-auth';
import { authHeader } from '@/helpers/utilities/auth-header';
import { validateToken } from '@/helpers/utilities';

class AccessService {
    async reloadSession(reloadAccessDto: ReloadAccessDto): Promise<SuccessResponseDto<boolean>> {
        await validateToken();

        const path = `/admin/access/reload-session`;
        const result = await http.get(path, {
            params: reloadAccessDto,
            headers: authHeader(),
            withCredentials: true
        });
        
        return result.data;
    }

    async search(params: SearchAccessDto): Promise<SuccessResponseDto<ResponseSearchAccessDto>> {
        await validateToken();
        const result = await http.get('/admin/access/search', {
            params: params,
            headers: authHeader(),
            withCredentials: true
        });
        return result.data;
    }


    async closeSession(closeSessionDto: CloseSessionDto): Promise<SuccessResponseDto<boolean>> {
        await validateToken();

        const path = `/admin/access/close-session`;
        const result = await http.delete(path, {
            params: closeSessionDto,
            headers: authHeader(),
            withCredentials: true
        });
        
        return result.data;
    }

}

export default new AccessService;